import { render, staticRenderFns } from "./checkBalance.vue?vue&type=template&id=683962e2&scoped=true&"
import script from "./checkBalance.vue?vue&type=script&lang=js&"
export * from "./checkBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683962e2",
  null
  
)

export default component.exports